import { isCapacitor } from '@src/utils/platformUtil.js'

let CapacitorPushNotifications = null
try {
  CapacitorPushNotifications = require('@capacitor/push-notifications').PushNotifications
} catch (e) {
  // Push Notifications plugin not installed
}

const isCapacitorPushAvailable = () => {
  return CapacitorPushNotifications !== null
}

export const isNotificationSupported = () => {
  if (isCapacitor() && isCapacitorPushAvailable()) {
    return true
  }
  return (
    typeof window !== 'undefined' &&
    (typeof window.Notification !== 'undefined' || typeof Notification !== 'undefined')
  )
}

export const getNotificationAPI = () => {
  if (typeof window !== 'undefined') {
    return window.Notification || (typeof Notification !== 'undefined' ? Notification : undefined)
  }
  return undefined
}

export const requestNotificationPermission = async () => {
  if (isCapacitor() && isCapacitorPushAvailable()) {
    try {
      const result = await CapacitorPushNotifications.requestPermissions()
      if (result.receive === 'granted') {
        return 'granted'
      }
      return 'denied'
    } catch (err) {
      console.error('[Notification] Error requesting Capacitor permission:', err)
      return 'denied'
    }
  }

  const NotificationAPI = getNotificationAPI()
  if (!NotificationAPI || typeof NotificationAPI.requestPermission !== 'function') {
    return 'denied'
  }

  try {
    if (NotificationAPI.permission === 'default') {
      return await NotificationAPI.requestPermission()
    }
    return NotificationAPI.permission || 'denied'
  } catch (err) {
    console.error('[Notification] Error requesting permission:', err)
    return 'denied'
  }
}

export const getNotificationPermission = async () => {
  if (isCapacitor() && isCapacitorPushAvailable()) {
    try {
      const result = await CapacitorPushNotifications.checkPermissions()
      if (result.receive === 'granted') {
        return 'granted'
      } else if (result.receive === 'denied') {
        return 'denied'
      }
      return 'default'
    } catch (err) {
      return 'default'
    }
  }

  const NotificationAPI = getNotificationAPI()
  if (!NotificationAPI || typeof NotificationAPI.permission === 'undefined') {
    return undefined
  }
  return NotificationAPI.permission
}

export const handleNotificationPermission = async ({ showToast, toastOptions } = {}) => {
  if (!isNotificationSupported()) {
    return 'denied'
  }

  let permission

  if (isCapacitor() && isCapacitorPushAvailable()) {
    try {
      const result = await CapacitorPushNotifications.checkPermissions()
      permission =
        result.receive === 'granted'
          ? 'granted'
          : result.receive === 'denied'
          ? 'denied'
          : 'default'
    } catch (err) {
      permission = 'default'
    }
  } else {
    permission = await getNotificationPermission()
  }

  if (permission === 'default') {
    return await requestNotificationPermission()
  } else if (permission === 'denied' && showToast) {
    const defaultMessage =
      'You have disabled the notification,if you want to get notification please enable it from info icon'
    const message = toastOptions?.message || defaultMessage
    const type = toastOptions?.type || 'info'

    showToast({
      message,
      type,
    })
  }

  return permission
}
